import {getFormData, submitFormDataViaAPI,} from '../utils/form';
import {handleCaptcha, initCaptcha, resetCaptcha} from '../utils/captcha';

const initPage = () => {

  if (!getForgotPasswordForm().length) {
    return;
  }

  initCaptcha(() => {
    requestResetPassword();
  });

  getForgotPasswordForm().submit(handleCaptcha(
    (e) => {
      requestResetPassword();

      return false;
    }
  ));
};

const getForgotPasswordForm = () => {
  return $("#forgot-password-form");
};

const requestResetPassword = async () => {
  const form = getForgotPasswordForm();
  let data = getFormData(form);
  await submitFormDataViaAPI(data, form);

  resetCaptcha();
}

$(initPage);
